import split from './split';

export default function ext(filename: string): string | null {
  const match = split(filename);
  return Array.isArray(match) ? match[1] : null;
}
